import { ITEM_SEARCH_LIMIT } from "~/constants/item"
import { ItemService } from "~/services/public/ItemService"
import { GET_FAKE_ID } from "~/store/listing"
import { findItemTypeByName } from "~/utils/item"

export const state = (): ItemSearch[] => []

export const GET_ITEMS = "getItems"

export const getters = {
  [GET_ITEMS]: (state: ItemSearch[]) => (searchString: string) => {
    let items

    if (
      searchString.length >= ITEM_SEARCH_LIMIT &&
      (items = state.find(itemSearch => itemSearch.key === searchString))
    ) {
      if (items && items.items !== undefined) {
        return items.items
      }

      return []
    } else {
      return []
    }
  }
}

export const _SET_RESPONSE = "setResponse"
export const _UPDATE_ITEM_SEARCH = "updateItemSearch"

export const mutations = {
  [_SET_RESPONSE](state: ItemSearch[], response: ItemSearch) {
    const index = state.findIndex(item => item.key === response.key)

    if (index !== -1) {
      state[index] = response // Update existing entry
    } else {
      state.push(response) // Add new entry
    }
  },
  [_UPDATE_ITEM_SEARCH](state: ItemSearch[], itemSearch: ItemSearch) {
    const key: string = itemSearch.key
    const item: Item = itemSearch.items[0]
    const itemsIndex = state.findIndex(itemSearch => itemSearch.key === key)
    const items: Item[] = state[itemsIndex].items
    const index: number = items.findIndex(
      it => it.fake_id === item.fake_id && it.location_id === item.location_id
    )

    item.fake_id = GET_FAKE_ID(item)
    state[itemsIndex].items[index] = item
  }
}

export const SEARCH_ITEMS = "searchItems"
export const INCREASE_ITEM_SEARCH = "increaseItemSearch"
export const DECREASE_ITEM_SEARCH = "decreaseItemSearch"

export const actions = {
  async [SEARCH_ITEMS]({ state, commit }, {$axios, $config, searchParams, locale}) {
    if (searchParams.name.length >= ITEM_SEARCH_LIMIT) {
      const itemService = new ItemService($axios, $config)
      const response = await itemService.searchItems(searchParams, locale)

      const itemSearch: ItemSearch = {
        key: searchParams.name,
        items: []
      }

      if (response) {
        itemSearch.items = response.data.map(item => {
          const realItem: any = Object.values(item.item_set)[0]

          return {
            item_id: realItem.item_id,
            name: realItem.name,
            original_width: realItem.original_width,
            original_depth: realItem.original_depth,
            original_height: realItem.original_height,
            original_weight: realItem.original_weight,
            dimension_unit: realItem.dimension_unit,
            weight_unit: realItem.weight_unit,
            fake_id: GET_FAKE_ID(realItem),
            quantity: 0,
            is_admin: realItem.is_admin,
            type: findItemTypeByName(realItem.name)
          }
        })
      }

      commit(_SET_RESPONSE, itemSearch)

      return itemSearch.items.length
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
